module.exports = __webpack_public_path__ + "media/images/front/centres/office_alger-efe1af330f0b6ba3ccb5c288ec927e93.webp";